exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#categoryOn[data-v-0d5be367]{border:1px solid red}a[data-v-0d5be367]{text-decoration:none}[data-v-0d5be367]:focus{border:3px solid orange}", ""]);

// exports
